import React from 'react';

import LinearProgress from '@material-ui/core/LinearProgress';
import PropTypes from 'prop-types';

import { Container } from './style';

export default function Progress({ loading }) {
  return (
    <Container load={loading}>
      <LinearProgress variant="query" />
    </Container>
  );
}

Progress.propTypes = {
  loading: PropTypes.bool,
};

Progress.defaultProps = {
  loading: false,
};
